import React from 'react';
import { DatePickerField } from './DatePickerField';
import { Filter } from './Filter';
import { Share } from './Share';
import { Filter as FilterType } from '../../model/Filter';

const Header = ({ filter, loading, downloadingExcel, onChange, onDownloadPdf, onDownloadExcel, onRefresh }: Props) => {
  const onChangeFilter = (locationId?: string[], locationName?: string[], installationId?: string, installationName?: string, campaignId?: string, campaignName?: string, zone?: string) => {
    onChange({ locationId: locationId, locationName: locationName, installationId: installationId, installationName: installationName, campaignId: campaignId, campaignName: campaignName, zone: zone });
  }

  return (
    <div className="card card-body pt-3 pb-3 mt-4 mb-4">
      <div className="d-flex align-items-center">
        <div style={{ width: 320 }}>
          <DatePickerField filter={filter} onChange={onChange} />
        </div>
        <div className="flex-grow-1">
          <Filter locationId={filter.locationId} installationId={filter.installationId} campaignId={filter.campaignId} zone={filter.zone} from={filter.from} to={filter.to} onChange={onChangeFilter} />
        </div>
        <div>
          {
            onRefresh &&
              <button type="button" className="btn btn-label-info waves-effect me-2" disabled={loading} onClick={onRefresh}>
                <i className={`ti ti-xs ti-refresh ${loading ? 'loading-icon' : ''}`} />
                <span className="ms-2 d-none d-lg-inline text-center" style={{ width: 51 }}>{loading ? 'Loading' : 'Refresh'}</span>
              </button>
          }
          <Share />
          <div className="btn-group">
            <button className="btn btn-label-secondary dropdown-toggle ms-2" type="button" disabled={loading && !downloadingExcel} data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i className="ti ti-xs ti-download" />
              <span className="ms-2 d-none d-lg-inline">Download</span>
            </button>
            <ul className="dropdown-menu">
              <li>
                <a className={`dropdown-item d-flex align-items-center ${loading ? 'disabled' : ''}`} onClick={onDownloadPdf}>PDF</a>
              </li>
              <li>
                <a
                  className={`dropdown-item d-flex align-items-center ${loading ? 'disabled' : ''}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    if(!loading) {
                      onDownloadExcel();
                    }
                  }}
                >
                  Excel
                  {
                    downloadingExcel &&
                      <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true" />
                  }
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  filter: FilterType,
  loading: boolean,
  downloadingExcel: boolean,
  onChange: (filter: FilterType) => void,
  onDownloadPdf: () => void,
  onDownloadExcel: () => void,
  onRefresh?: () => void
}

export { Header };
